import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Col, Container, Image, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import Thumb from './common/Thumb';
import parse, { domToReact } from 'html-react-parser'

const Series = () => {
    async function getSeriesInfo(userIdOrDisplayId,seriesLink){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/info/"+userIdOrDisplayId+"/"+seriesLink).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t} = useTranslation()
    const params = useParams()
    const location = useLocation()
	const [title,setTitle] = useState("")
    const [mode,setMode] = useState()
    const [seriesInfo,setSeriesInfo] = useState([])
    const [seriesDetail,setSeriesDetail] = useState([])

	useEffect(() => {
		document.querySelector("title").textContent = title + " - " + t("common.siteName")
        if(params.user_id_or_display_id !== undefined && params.series_link){
            // 個別表示
            setMode("info")
        } else if(params.user_id_or_display_id !== undefined && params.series_link === undefined){
            // 一覧表示
            setMode("list")
        }
	},[location.pathname])

    useEffect(() => {
        if(mode === "info"){
            // シリーズ
            getSeriesInfo(params.user_id_or_display_id,params.series_link).then(r => {
                if(r.result){
                    setSeriesInfo(r.data.info)
                    setSeriesDetail(r.data.detail)
                    setTitle(r.data.info.series_name)
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        } else {
            // あとで実装
        }
    },[mode,params.series_link])

    let ageLimit = ["全年齢","PG12","R15","R18","R18G"]

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        {seriesInfo.length !== 0 ? (
        <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
            <div className='d-flex justify-content-start'>
                <div>
                    <div>
                        <Image data-type="follower" data-observe="0" data-no={0} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/series/"+seriesInfo.series_id+".webp?"+seriesInfo.update_datetime} style={{width:"300px",height:"auto",borderRadius:"5px"}} />
                    </div>
                </div>
                <div style={{marginLeft:"10px"}}>{seriesInfo.series_name}<br />
                {parse(seriesInfo.series_description.replace(/\r|\n|\r\n/g,"<br/>"),{})}<br /><br />
                年齢制限：{ageLimit[seriesInfo.series_age_limit-1]}<br />
                </div>
            </div>
        </Container>
        ) : ""}
        <Container className='d-flex flex-row justify-content-start flex-wrap w-100 mt-3'>
            {seriesDetail.map((data,i) => {
                return <Thumb data={data} i={i} dialog={dialog} key={i} userInfoHidden={true} list={seriesDetail.filter(d => d.mute === 0)} listName={title} />
            })}
        </Container>
        <Footer />
    </div>
    )
}

export default Series;
